export function ScorePill({ score, testId }) {
  const s = Number(score || 0);
  let cls = "text-[#FF3333] bg-[#FF3333]/10 border-[#FF3333]/30";
  if (s >= 80) cls = "text-[#00A850] bg-[#00A850]/10 border-[#00A850]/30";
  else if (s >= 50) cls = "text-[#E3000B] bg-[#E3000B]/10 border-[#E3000B]/30";
  return (
    <span data-testid={testId} className={`inline-flex items-center justify-center h-6 px-2 rounded-sm font-mono text-xs font-bold border ${cls}`}>
      {s.toFixed(0)}
    </span>
  );
}

export function RiskPill({ risk, testId }) {
  const map = {
    LOW: "text-[#00A850] bg-[#00A850]/10 border-[#00A850]/30",
    MEDIUM: "text-[#E3000B] bg-[#E3000B]/10 border-[#E3000B]/30",
    HIGH: "text-[#FF3333] bg-[#FF3333]/10 border-[#FF3333]/30",
  };
  return (
    <span data-testid={testId} className={`inline-flex items-center h-5 px-1.5 rounded-sm font-mono text-[10px] font-bold uppercase border ${map[risk] || map.MEDIUM}`}>
      {risk}
    </span>
  );
}

export function ConfidencePill({ confidence, testId }) {
  return (
    <span data-testid={testId} className="inline-flex items-center h-5 px-1.5 rounded-sm font-mono text-[10px] uppercase border border-[#E4E4E0] text-gray-600">
      {confidence}
    </span>
  );
}

export function ROICell({ value }) {
  const v = Number(value || 0);
  let color = "text-gray-600";
  if (v >= 20) color = "text-[#00A850]";
  else if (v >= 10) color = "text-[#E3000B]";
  else if (v < 0) color = "text-[#FF3333]";
  return <span className={`font-mono font-bold ${color}`}>{v >= 0 ? "+" : ""}{v.toFixed(1)}%</span>;
}
